import { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";

import { formatRelativeDate } from "../../../../../services/helper";
import { colors } from "../../../../../utils/constants/colors";
import { modifyNotification } from "../../../../../redux/actions/notification";
import { toast } from "../../../../CommonComponents/ToastComponent/toast";
import { AppContext } from "../../../../../context";

const Email = ({ key, notification, setCurrentPage, setSelectedNotification, setCheckedKeys }) => {
    const history = useHistory()
    const dispatch = useDispatch()
      const {
        getNewUnreadNotification
      } = useContext(AppContext);

    const [checked, setChecked] = useState(false)

    let supplier = { type: '', id: null }

    const onDetailHandler = async (domain, emailChainId, to) => {
        let notificationIds = []
        notificationIds.push(notification?.id)
        const updateResult = await dispatch(modifyNotification(notificationIds, "markAsRead")).then((res) => res).catch((err) => {
            getNewUnreadNotification()
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Modify From Unread To Read'
                })
            }
        })
        setCurrentPage('notificationDetail')
        setSelectedNotification({ domain: notification?.domain, emailChainId: notification?.emailChainId, registeredEmail: notification?.emailTo })
        history.push(`/tasks/notifications/emailDetail?domain=${domain}&emailChainId=${emailChainId}&registeredEmail=${to}`)
    }

    const checkHandler = (checked) => {
        setChecked(checked)
        checked ? setCheckedKeys(prevState => [...prevState, notification?.id]) : setCheckedKeys(prevState => prevState?.filter(id => id !== notification?.id))
    }

    let time = formatRelativeDate(notification?.notificationCreatedAt)
    let preview = notification?.bodyPreview?.length < 40 ? notification?.bodyPreview : notification?.bodyPreview?.slice(0, 40) + '...'
    
    return (
        <div key={key} className={`container-fluid py-2 py-3 d-flex column-gap-3 mb-3 rounded ${!notification?.isRead && 'border'}`} style={{ backgroundColor: notification?.isRead ? "aliceblue" : "#fff" }}>
            <div className="d-flex column-gap-4 col-1 align-items-center">
                <button className="rounded-circle border p-2" style={{ width: '50px', height: '50px' }}><i class="bi bi-person-square fs-2"></i></button>
                <input type="checkbox" style={{ width: 15, height: 15 }} onChange={(e) => { checkHandler(e?.target?.checked, notification?.id) }} checked={checked} />
            </div>
            <div className="d-flex col-11 column-gap-3">
                <div className="col-2 align-self-center" style={{overflow: 'hidden'}}>
                    {
                        !notification?.contactId ?
                            <p
                                className="m-0"
                                style={{ fontSize: 14, color: colors.linkBlue }}
                            >
                                {notification?.emailFrom?.slice(0, 50)}
                            </p> :
                            <Link
                                to={`/contacts/${notification?.contactId}`}
                                className="m-0"
                                style={{ fontSize: 14, color: colors.linkBlue }} target='_blank'
                            >
                                {notification?.emailFrom?.slice(0, 20)}
                            </Link>
                    }
                </div>
                {/* <div className="col-3  align-self-center">
                    {!notification?.supplierId && !notification?.listSupplierId ?
                        <p className="m-0" style={{ fontSize: 14 }}>No Supplier Detected</p> :
                        <Link
                            className="m-0"
                            style={{ fontSize: 14, color: colors.linkBlue }}
                            to={supplier?.type === "masterSupplier" ? `suppliers/${supplier?.id}` : `lists/insequence/addcallerdetails/${supplier.id}`}
                        >
                            <div className="d-flex column-gap-2">
                                <span style={{ textDecoration: 'none' }}>{!notification?.supplierId ? '' : notification?.supplierId ? '(MS)' : '(LS)'}</span>
                                <span>{notification?.supplierId ? notification?.supplierName : notification?.listSupplierName}</span>
                            </div>
                        </Link>
                    }
                </div> */}
                 <div className="col-3  align-self-center">
                    <p className="m-0" style={{ fontSize: 14 }}>{notification?.subject}</p>
                </div>
                <div className="col-3  align-self-center">
                    <p className="m-0" style={{ fontSize: 14 }}>{preview}</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0" style={{ fontSize: 14 }}>{time}</p>
                </div>
                <div className="col-1  align-self-center ">
                    <p className="m-0" style={{ fontSize: 14 }}>{notification?.isRead ? 'Read' : 'Unread'}</p>
                </div>
                <div className="col-2  align-self-center">
                    <button className="report_small_button_success" onClick={() => { onDetailHandler(notification?.domain, notification?.emailChainId, notification?.emailTo) }}>Details</button>
                </div>
            </div>


        </div>

    )
}

export default Email 